import React from 'react'
import { twMerge } from 'tailwind-merge'
import { ModalWindowSizeEnum } from '../types'
import { TertiaryButton } from 'src/editor/shared/ui-lib/buttons'
import { PrimaryButton } from 'src/editor/shared/ui-lib/buttons'

export interface ModalWindowFooterProps {
  size: ModalWindowSizeEnum
  firstButtonProps?: React.ComponentProps<typeof TertiaryButton>
  secondButtonProps?: React.ComponentProps<typeof PrimaryButton>
  className?: string
}
export const ModalWindowFooter = ({
  size,
  firstButtonProps,
  secondButtonProps,
  className,
}: ModalWindowFooterProps) => {
  return firstButtonProps || secondButtonProps ? (
    <div
      className={twMerge(
        'flex w-full items-center justify-start gap-3 border-border200 border-t',
        size === ModalWindowSizeEnum.Small && 'px-6 py-3',
        size === ModalWindowSizeEnum.Medium && 'px-8 pt-5 pb-6',
        className,
      )}
    >
      {firstButtonProps && <TertiaryButton {...firstButtonProps} />}
      {secondButtonProps && <PrimaryButton {...secondButtonProps} />}
    </div>
  ) : null
}
